import type { ReactNode } from 'react'
import {
  TileIcon,
  TileLabel,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/styled-components'

interface TileContentProps {
  icon: ReactNode
  label: string
}

const TileContent = ({ icon, label }: TileContentProps) => (
  <>
    <TileIcon data-role='tile-icon'>{icon}</TileIcon>
    <TileLabel>{label}</TileLabel>
  </>
)

export default TileContent
